/**
 * DashboardSetup entity class
 */

/**
 * DashboardSetupFactory
 * returns DashboardSetup entity class
 *
 * @class DashboardSetupFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DashboardSetup} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DashboardSetupFactory
 */
/* @ngInject */
export default function DashboardSetupFactory ($http, Entity, onOffMixin, storageSvc) {
  /* === DashboardSetup class === */

  /**
   * DashboardSetup model
   *
   * @class DashboardSetup
   * @classdesc DashboardSetup model
   * @memberof models
   * @see models
   * @mixes models.onOffMixin
   * @extends models.Entity
   * @return {models.DashboardSetup} DashboardSetup entity
   */
  function DashboardSetup () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DashboardSetup.prototype = Object.create(Entity.prototype)
  DashboardSetup.prototype.constructor = DashboardSetup

  /* === DashboardSetup instance methods & fields === */

  Object.assign(DashboardSetup.prototype, {

    /**
     * Default settings structure
     *
     * @memberof models.DashboardSetup#
     * @type {Object}
     */
    _settings: {
      MAP_CARD: null,
      ACTIVE_SUBSCRIBERS_GRAPH_CARD: {
        name: 'Number of active subscribers',
        enabled: false,
        period: 7
      },
      // payments
      DYNAMICS_BY_PAYMENT_GRAPH_CARD: {
        name: 'Dynamics by payment types graph',
        enabled: false,
        period: 7
      },
      DYNAMICS_BY_PAYMENT_SYSTEM_GRAPH_CARD: {
        name: 'Dynamics by payment system types graph',
        enabled: false,
        period: 7
      },
      /* payments */
      PAYMENTS_BY_TYPES_GRAPH: {
        name: 'Transactions of Payment Services',
        paymentsDynamicsByTypes: true,
        enabled: false,
        period: 7,
        systemTypes: []
      },
      AUTOPAY_PAYMENTS_GRAPH: {
        name: 'Amount of autopay charges',
        enabled: false,
        period: 7
      },
      // cards
      AUTOPAY_PAYMENTS_CARD: {
        name: 'Autopayment amount',
        enabled: true,
        period: 7
      },
      ALL_PAYMENTS_CARD: {
        name: 'Amount of total payments',
        enabled: true,
        period: 7
      },
      CASH_PAYMENTS_CARD: {
        name: 'Amount of Cash payments',
        enabled: false,
        period: 7
      },
      AUTHORIZE_PAYMENTS_CARD: {
        name: 'Amount of Authorize.net payments',
        enabled: true,
        period: 7
      },
      CHECK_PAYMENTS_CARD: {
        name: 'Amount of Check payments',
        enabled: false,
        period: 7
      },
      EXTERNAL_PAYMENTS_CARD: {
        name: 'Amount of External payments',
        enabled: false,
        period: 7
      },
      CCPP_PAYMENTS_CARD: {
        name: 'Amount of CCPP payments',
        enabled: false,
        period: 7
      },
      GR4VY_PAYMENTS_CARD: {
        name: 'Amount of Gr4avy payments',
        enabled: false,
        period: 7
      },
      GOCARDLESS_PAYMENTS_CARD: {
        name: 'Amount of GoCardless payments',
        enabled: false,
        period: 7
      },
      TRUE_MONEY_PAYMENTS_CARD: {
        name: 'Amount of True Money payments',
        enabled: false,
        period: 7
      },
      TRUE_ONLINE_PAYMENTS_CARD: {
        name: 'Amount of TrueOnline payments',
        enabled: false,
        period: 7
      },
      TRUE_MOVE_H_PAYMENTS_CARD: {
        name: 'Amount of TrueMove-H payments',
        enabled: false,
        period: 7
      },
      AIRWALLEX: {
        name: 'Amount of Airwallex payments',
        enabled: false,
        period: 7
      },
      PAYPAL_PAYMENTS_CARD: {
        name: 'Amount of PayPal payments',
        enabled: false,
        period: 7
      },
      EPG_BLOCK: {
        name: 'EPG tasks status',
        enabled: true
      },
      STREAMS_BLOCK: {
        name: 'Streams status',
        enabled: true
      }
    },

    /**
     * instance fields
     *
     * @memberof models.DashboardSetup#
     * @type {Object}
     */
    _fields: {
      // settings: Object
    }, // ...

    /**
     * Getter for settings
     *
     * @returns {Object}
     */
    settings () {
      const dashboardSetup = storageSvc.local.get('dashboardSetup', null)

      return Object.assign(angular.copy(this._settings), dashboardSetup)
    },

    /**
     * Rewrite dashboard setup from storage
     *
     * @param settings
     * @private
     */
    _update (settings) {
      storageSvc.local.set('dashboardSetup', settings)
    }

  }, onOffMixin)

  /* === DashboardSetup static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DashboardSetup, Entity)
  DashboardSetup._name = 'DashboardSetup'
  DashboardSetup.init()

  return DashboardSetup
}
